import { createApp } from 'vue'
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { dom } from "@fortawesome/fontawesome-svg-core";
import { get } from 'lodash'
import App from './App'
import TotalApp from './TotalApp'
import { createPinia } from 'pinia'

library.add(far);
library.add(fab);
library.add(fas);

dom.watch();

const pinia = createPinia()
const app = createApp(App)
    .component("font-awesome-icon", FontAwesomeIcon)

app.config.globalProperties.bundleData = get(window, `BUNDLEDATA`);
app.config.globalProperties.offers = get(window, `FoolOffers`);
app.config.globalProperties.commercejs = get(window, `Fool.Commerce`);
app.config.globalProperties.ga = get(window, `ga`);
app.config.globalProperties.commerceSettings = get(window, 'commerceSettings');

app.use(pinia)
app.mount('#commerce-app')

// This lets the price total display be mounted multiple times since it's included in each payment type template
const createTotalApp = (element) => {
  const totalApp = createApp(TotalApp)
  totalApp.config.globalProperties.bundleData = get(window, `BUNDLEDATA`);
  totalApp.use(pinia)
  totalApp.mount(element)
}
const totalElements = document.getElementsByClassName('commerce-total-app')
let el
for (el of totalElements) {
  createTotalApp(el)
}

